import { comiteElectoralData } from '@/mocks/nosotros-data';

export default function ComiteElectoral() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          {/* Intro */}
          <div className="mb-10 md:mb-14">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Procesos electorales
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
              {comiteElectoralData.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
              {comiteElectoralData.description}
            </p>
          </div>

          {/* Members */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {comiteElectoralData.members.map((member) => (
              <div
                key={member.name}
                className="group rounded-2xl bg-background-100 border border-secondary-200/60 p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300 text-center"
              >
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-checkbox-circle-line text-2xl" />
                </span>
                <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                  {member.name}
                </h4>
                <span className="text-accent-600 text-xs font-medium whitespace-nowrap">
                  {member.role}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}